import React from 'react';
import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css';
import css from './productSlider.module.css';
import { IconCollection, ListingCard } from '../../../components';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1.5,
  },
};

const CustomRightArrow = ({ onClick, ...rest }) => {
  const {
    onMove,
    carouselState: { currentSlide, deviceType },
  } = rest;
  // onMove means if dragging or swiping in progress.
  return (
    <div onClick={() => onClick()} className={css.sliderRightButton}>
      <IconCollection icon="SliderNextIcon" />
    </div>
  );
};

const CustomLeftArrow = ({ onClick, ...rest }) => {
  const {
    onMove,
    carouselState: { currentSlide, deviceType },
  } = rest;
  // onMove means if dragging or swiping in progress.
  return (
    <button onClick={() => onClick()}>
      <IconCollection icon="nextIcon" />
    </button>
  );
};

class ProductSlider extends React.Component {
  state = { additionalTransfrom: 0 };
  render() {
    const {
      renderSizes,
      onActivateListing,
      pageListings,
      paginationLinks,
      CategorySelected,
      isFeaturedSection = false,
    } = this.props;

    const CustomSlider = ({ carouselState }) => {
      let value = 0;
      let carouselItemWidth = 0;
      if (this.Carousel) {
        carouselItemWidth = this.Carousel.state.itemWidth;
        const maxTranslateX = Math.round(
          // so that we don't over-slide
          carouselItemWidth * (this.Carousel.state.totalItems - this.Carousel.state.slidesToShow) +
            150
        );
        value = maxTranslateX / 100; // calculate the unit of transform for the slider
      }
      const { transform } = carouselState;
      return (
        <div className="custom-slider">
          {(isFeaturedSection && pageListings.length > 5) || !isFeaturedSection ? (
            <input
              type="range"
              value={Math.round(Math.abs(transform) / value) || 0}
              max={
                (carouselItemWidth * (carouselState.totalItems - carouselState.slidesToShow) +
                  (this.state.additionalTransfrom === 150 ? 0 : 150)) /
                value
              }
              onChange={e => {
                if (this.Carousel.isAnimationAllowed) {
                  this.Carousel.isAnimationAllowed = false;
                }
                const nextTransform = e.target.value * value;
                const nextSlide = Math.round(nextTransform / carouselItemWidth);
                if (e.target.value == 0 && this.state.additionalTransfrom === 150) {
                  this.Carousel.isAnimationAllowed = true;
                  this.setState({ additionalTransfrom: 0 });
                }
                this.Carousel.setState({
                  transform: -nextTransform, // padding 20px and 5 items.
                  currentSlide: nextSlide,
                });
              }}
              className="custom-slider__input"
            />
          ) : null}
        </div>
      );
    };
    return (
      <div className={css.carouselContainer}>
        <Carousel
          ssr={false}
          ref={el => (this.Carousel = el)}
          partialVisbile={false}
          customRightArrow={<CustomRightArrow />}
          customButtonGroup={<CustomSlider />}
          itemClass="slider-image-item"
          responsive={responsive}
          containerClass="carousel-container-with-scrollbar"
          additionalTransfrom={-this.state.additionalTransfrom}
          beforeChange={nextSlide => {
            if (nextSlide !== 0 && this.state.additionalTransfrom !== 150) {
              this.setState({ additionalTransfrom: 150 });
            }
            if (nextSlide === 0 && this.state.additionalTransfrom === 150) {
              this.setState({ additionalTransfrom: 0 });
            }
          }}
        >
          {pageListings.map(l => {
            return (
              <ListingCard
                className={css.listingCard}
                key={l.id.uuid}
                listing={l}
                renderSizes={renderSizes}
                CategorySelected={CategorySelected}
                setActiveListing={onActivateListing}
              />
            );
          })}
        </Carousel>
      </div>
    );
  }
}

export default ProductSlider;
